/**
 * @fileoverview POST handler for the "/integrations/scim/scim_install" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsScimScimInstallCacheKeys } from "./constants";
import type { PostIntegrationsScimScimInstallProps, IntegrationsScimScimInstallResult } from "./types";

export const postIntegrationsScimScimInstall = reactQueryMutationAdapter(
  integrationsScimScimInstallCacheKeys,
  (props: PostIntegrationsScimScimInstallProps): Promise<IntegrationsScimScimInstallResult> => {
    // manipulate props here as needed { idp, default_ag_id, ip_whitelist, identity_provider_company_id }

    return fetch("/integrations/scim/scim_install", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
